import axios from "axios";
import { useMutation, useQuery } from "react-query";
import { QUERY_KEYS } from "../constants/reactQueryKeyConsts";

export const useGetCaseHistoryData= () => {
     return useMutation({
        mutationFn: async ({body, config}) => {
            return axios.get(`${process.env.REACT_APP_API_URI}DownloadCase?report=${body.report}&caseId=${body.case_id}`, config).then((res) => res.data).catch(err => err);
          }, 
     })
  }